/**
 * TanStack Query hooks for `lead-ping-tree-ping-post-productized-module`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	leadPingTreePingPostProductizedModuleQueryKeys,
	type CreateLeadPingTreePingPostProductizedModuleBody,
	type ListLeadPingTreePingPostProductizedModuleResponse,
	type LeadPingTreePingPostProductizedModuleRow,
} from "./api";

export function useLeadPingTreePingPostProductizedModuleList(): UseQueryResult<ListLeadPingTreePingPostProductizedModuleResponse, Error> {
	return useQuery({
		queryKey: leadPingTreePingPostProductizedModuleQueryKeys.list(),
		queryFn: list,
	});
}

export function useLeadPingTreePingPostProductizedModuleCreate(): UseMutationResult<LeadPingTreePingPostProductizedModuleRow, Error, CreateLeadPingTreePingPostProductizedModuleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leadPingTreePingPostProductizedModuleQueryKeys.all });
		},
	});
}

export function useLeadPingTreePingPostProductizedModuleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leadPingTreePingPostProductizedModuleQueryKeys.all });
		},
	});
}
